import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "template", "addButton"]
  static values = { 
    max: { type: Number, default: 3 },
    fallbackContext: { type: String, default: "business" }
  }

  connect() {
    this.updateAddButtonVisibility()
    this.boundUpdateVisibility = this.updateAddButtonVisibility.bind(this)
    this.element.addEventListener("row:removed", this.boundUpdateVisibility)
  }

  disconnect() {
    this.element.removeEventListener("row:removed", this.boundUpdateVisibility)
  }

  add(event) {
    event.preventDefault()
    
    const visibleCount = this.countVisibleItems()
    if (visibleCount >= this.maxValue) {
      return
    }

    const uniqueId = Date.now().toString()
    const fragment = this.templateTarget.content.cloneNode(true)
    this.replaceTemplateTokens(fragment, uniqueId)
    this.containerTarget.appendChild(fragment)

    // Set the appropriate default context for the new item
    const newItem = this.containerTarget.lastElementChild
    this.setDefaultContext(newItem)
    
    this.updateAddButtonVisibility()
  }

  setDefaultContext(newItem) {
    if (!newItem) return

    // Check if "main" is already used by another visible item
    const mainInUse = this.isContextInUse("main")
    
    // Find the context select in the new item
    const contextSelect = newItem.querySelector("select[name*='[context]']")
    if (contextSelect) {
      if (mainInUse) {
        // Set to fallback context
        contextSelect.value = this.fallbackContextValue
      } else {
        // Set to main
        contextSelect.value = "main"
      }
    }
  }

  isContextInUse(context) {
    const items = this.containerTarget.querySelectorAll("[data-nested-form-target='item']")
    for (const item of items) {
      if (item.classList.contains("hidden")) continue
      
      const contextSelect = item.querySelector("select[name*='[context]']")
      if (contextSelect && contextSelect.value === context) {
        return true
      }
    }
    return false
  }

  countVisibleItems() {
    // Count items directly from container that aren't hidden
    const items = this.containerTarget.querySelectorAll("[data-nested-form-target='item']")
    return Array.from(items).filter(item => !item.classList.contains("hidden")).length
  }

  updateAddButtonVisibility() {
    if (!this.hasAddButtonTarget) return
    
    const visibleCount = this.countVisibleItems()
    
    if (visibleCount >= this.maxValue) {
      this.addButtonTarget.classList.add("hidden")
    } else {
      this.addButtonTarget.classList.remove("hidden")
    }
  }

  replaceTemplateTokens(node, token) {
    if (node.nodeType === Node.TEXT_NODE) {
      if (node.nodeValue?.includes("NEW_RECORD")) {
        node.nodeValue = node.nodeValue.replaceAll("NEW_RECORD", token)
      }
      return
    }

    if (node.nodeType === Node.ELEMENT_NODE) {
      for (const attr of node.attributes) {
        if (attr.value.includes("NEW_RECORD")) {
          node.setAttribute(attr.name, attr.value.replaceAll("NEW_RECORD", token))
        }
      }
    }

    for (const child of node.childNodes) {
      this.replaceTemplateTokens(child, token)
    }
  }
}
